module.exports = __webpack_public_path__ + "img/credit-card.5f458403.svg";